import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import cN from 'classnames';

import {LessonShape} from '../../lessons/shapes';

import Download from './DownloadButton';

const QuestionnaireEntry = ({id, name, blocks, disabled, completed}) => !completed && (
    <Link
        to={`/${id}/`}
        className={cN(
            'w-full rounded-sm p-4 flex flex-col items-center cursor-pointer',
            {
                'pointer-events-none bg-grey-light': disabled,
                'bg-yellow text-white': !disabled,
            }
        )}
    >
        <span className="title">{name}</span>
        <Download blocks={blocks} />
    </Link>
);

QuestionnaireEntry.propTypes = LessonShape;

const mapStateToProps = ({questionnaire}, {id}) => {
    return ({
        ...questionnaire[id],
        disabled: false,
    });
};

export default connect(mapStateToProps, {})(QuestionnaireEntry);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/QuestionnaireEntry.js